module.exports = __webpack_public_path__ + "img/battery_3disable.ccf49e79.png";